import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutUsComponent } from 'src/app/view/about-us/about-us.component';
import { PrincipalComponent } from 'src/app/view/about-us/principal/principal.component';
import { VisionComponent } from 'src/app/view/about-us/vision/vision.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AboutUsComponent,
    VisionComponent,
    PrincipalComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {path:'',component:AboutUsComponent,children:[
        {path:'vision',component:VisionComponent},
        {path:'principal',component:PrincipalComponent}
      ]}
    ])
  ]
})
export class AboutModule { }
